import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const DeploymentContext = createContext(null);
export const useDeployment = () => useContext(DeploymentContext);

export function DeploymentProvider({ children }) {
  const [deployment, setDeployment] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await api.get("/contract/deployment", { params: { network: "mainnet" } });
      setDeployment(data);
    } catch (e) {} finally { setLoading(false); }
  };

  useEffect(() => { refresh(); }, []);

  const deployed = !!(deployment && deployment.package_id);
  return (
    <DeploymentContext.Provider value={{ deployment, deployed, loading, refresh }}>
      {children}
    </DeploymentContext.Provider>
  );
}
